import React, { type FC, useEffect, useRef, useState } from "react";
import DataTableExpandableRow from "src/components/DataTable/DataTableExpandableRow";
import DataTableRow, {
  type DataTableRowProps,
} from "src/components/DataTable/DataTableRow";
import type { NestTestResultError } from "src/api/interfaces/nest/history";
import NestErrorDetailContent from "./NestErrorDetailContent";

const canExpand = (row: NestTestResultError) =>
  !!(row.detailedMessage || row.solutionPath);

const NestErrorDataTableRow: FC<DataTableRowProps<NestTestResultError>> = ({
  id,
  content,
  contents,
  columnsDefinition,
  rowClickHandler,
  rowURLBuilder,
  selectDispatcher,
  shouldBeSelectable,
  customDataTableRowProps,
}) => {
  const hasExpandableContent = canExpand(content);
  const collapseKey = customDataTableRowProps?.collapseKey;
  const [forceCollapse, setForceCollapse] = useState(false);
  const prevCollapseKey = useRef(collapseKey);

  useEffect(() => {
    if (prevCollapseKey.current !== collapseKey) {
      setForceCollapse(true);
      prevCollapseKey.current = collapseKey;
    }
  }, [collapseKey]);

  useEffect(() => {
    if (forceCollapse) {
      setForceCollapse(false);
    }
  }, [forceCollapse]);

  const DataTableRowComponent = hasExpandableContent
    ? DataTableExpandableRow
    : DataTableRow;

  return (
    <DataTableRowComponent
      id={id}
      content={content}
      contents={contents}
      columnsDefinition={columnsDefinition}
      rowClickHandler={rowClickHandler}
      rowURLBuilder={rowURLBuilder}
      selectDispatcher={selectDispatcher}
      shouldBeSelectable={shouldBeSelectable}
      onExpandHandler={() => {}}
      expandedProp={forceCollapse ? false : undefined}
    >
      {hasExpandableContent && <NestErrorDetailContent content={content} />}
    </DataTableRowComponent>
  );
};

export default NestErrorDataTableRow;
